<template>
  <div class="hello flex_c" style="width: 100%;height: 100%">
    <div style="height: 100%;background-color: White;padding: 0 15px;overflow-x: hidden;">

      <div class="row top" >

        <img src="../assets/image/bind_success.png" style="width: 91px;height: 91px;margin-left: calc((100% - 91px)/2);margin-top: 180px" />
        <div  style="text-align: center;font-size: 28px;margin-top: 30px;margin-bottom: 15px">绑定成功</div>

        <!--<button style="line-height: 44px;background-color: #5e4fff;text-align: center;color: white;-->
          <!--border:none;padding: 0 40px; font-size: 14px; height: 44px;margin: 0 auto;display: block;;position: relative-->
          <!--">点我打开小程序，完善个人简历！-->
        <!--</button>-->

        <wx-open-launch-weapp id="launch-btn" username="gh_b6156951aeb6" path="/pages/position/positionMain.html">
           <script type="text/wxtag-template">
             <button style="line-height: 44px;background-color: #5e4fff;text-align: center;color: white;
              border:none;padding: 0 40px; font-size: 14px;border-radius: 2px; height: 44px;margin: 0 auto;display: block;;position: relative
              ">点我打开小程序，完善个人简历！</button>
           </script>
        </wx-open-launch-weapp>
        <div v-if="!isWeixinOpen" style="margin-top: 15px;text-align: center;padding: 0 15px">

          您的微信版本较低无法拉起小程序，请在小程序搜索“工作啦”进入。

        </div>

        <div>
        </div>
      </div>
      <!--username="gh_b6156951aeb6"-->

    </div>
  </div>

</template>

<script>
  var wx = require('weixin-js-sdk')

  export default {
    name: 'bindSuccess',
    data() {
      return {
        isWeixinOpen: false
      }
    },
    created() {
      this.xcx()
    },
    methods: {
      xcx () {
        var ua = window.navigator.userAgent.toLowerCase();
        // 微信内核判断
        if (ua.indexOf('micromessenger') === -1) {
          this.isWeixinOpen = false
        }
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        let judgewechat;
        if (wechat) {
          judgewechat = wechat[1].split('.')
          if (judgewechat[0] >= 7) {
            if (judgewechat[1] >= 0) {
              if (judgewechat[2] >= 12) {
                console.log('当前符合 h5 打开小程序')
                console.log(location.href.split('#')[0], 'location.href.split(\'#\')[0]');
                let params = {
                  collegeid: 'wechatofficial0000talent',
                  url: encodeURIComponent(location.href.split('#')[0]),
                  type: 'talentservice'
                }
                this.$api.getWechatInfo(params)
                  .then((res) => {
                    console.log(res, 'getWechatJssdk1');
                    if (res) {
                      var wxConfigArr = []
                      // 通过config接口注入 权限验证配置并申请所需开放标签
                      wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                        appId: res.AppId, // 必填，公众号的唯一标识
                        timestamp: res.Timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.NonceStr, // 必填，生成签名的随机串
                        signature: res.Signature,// 必填，签名
                        jsApiList: ['wx-open-launch-weapp'], // 必填，需要使用的JS接口列表
                        openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app'],
                      })
                      this.isWeixinOpen = true
                      wx.ready(function() {
                      })
                      wx.error(function (res) {
                        console.log('error', res)
                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
                      })
                      wxConfigArr.push(res.AppId, res.Timestamp, res.NonceStr, res.Signature);
                      console.log('初始化成功', wxConfigArr)
                    } else {
                      this.isWeixinOpen = true
                    }
                  });

              } else {
                this.isWeixinOpen = true
              }
            }
          }
        }
      },
    }
  }
</script>

<style scoped>
  .top{
    box-sizing: border-box;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/bindSuccess.vue